import { ChangeEvent } from "react";
import Slider from "../../../../../../../../library/slider";
import { getIcon } from "../../../../../../../../utils/get-icon";
import { useSettings } from "../../../../context";

import {
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  AccordionTitle,
  InnerAccordionHeader,
  ResetButton,
  SliderWrapper,
  ValueInput,
  ValueInputIcon,
  ValueInputWrapper,
} from "./styled";
import { AvailableFilter } from "../../../../../types";

type FilterControlProps = {
  config: AvailableFilter;
  currentValue: number;
};

const FilterControl = ({ config, currentValue }: FilterControlProps) => {
  const { setFilterValue } = useSettings();

  const handleValueChange = (newValue: number) => {
    setFilterValue(config.value, newValue);
  };

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = parseInt(e.target.value, 10);
    if (!isNaN(value)) {
      const clampedValue = Math.max(config.min, Math.min(value, config.max));
      handleValueChange(clampedValue);
    }
  };

  const handleSliderChange = (value: number | number[]) => {
    const numericValue = Array.isArray(value) ? value[0] : value;
    if (!isNaN(numericValue)) {
      handleValueChange(numericValue);
    }
  };

  const renderUnitIcon = () => {
    if (config.unit === "px" || config.unit === "deg") {
      return <ValueInputIcon>{config.unit}</ValueInputIcon>;
    }
    return <ValueInputIcon>{getIcon("percentage")}</ValueInputIcon>;
  };

  const clickReset = () => {
    handleValueChange(config.defaultValue);
  };

  return (
    <AccordionItem key={config.value} eventKey={config.value}>
      <AccordionHeader>
        <InnerAccordionHeader>
          <AccordionTitle>{config.title}</AccordionTitle>
        </InnerAccordionHeader>
      </AccordionHeader>
      <AccordionBody>
        <SliderWrapper>
          <Slider
            min={config.min}
            max={config.max}
            step={1}
            value={Number(currentValue)}
            onChange={handleSliderChange}
            dots={false}
          />
          <ValueInputWrapper>
            {renderUnitIcon()}
            <ValueInput
              type="number"
              min={config.min}
              max={config.max}
              onChange={handleInputChange}
              value={Number(currentValue)}
            />
          </ValueInputWrapper>
          <ResetButton onClick={clickReset}>{getIcon("reset")}</ResetButton>
        </SliderWrapper>
      </AccordionBody>
    </AccordionItem>
  );
};

export default FilterControl;
